import {useMutation} from "@tanstack/react-query";

import {deleteServiceMutationOptions} from "./delete-service.mutation-options";

export function useDeleteService() {
  return useMutation(deleteServiceMutationOptions());
}
